import React from 'react';
import {Image, PageHeader} from "antd";

const Taskpage = () => {
    return (
        <>
            <PageHeader
                className="site-page-header"
                title="Страница задания"
            />
            <h3>Окно задачи с подробной информацией о ней - компонент <code>TaskPageDrawer</code></h3><br/>
            <Image
                width={800}
                src="https://res.cloudinary.com/dv4fxot90/image/upload/v1601228856/documentation/Screenshot_2020-09-27_at_20.47.22_pemtnc.png"
            /><br/><br/>
            <p>Открытие окна задачи доступно в режиме Admin и Student по клику на кнопку more в режимах просмотра Table и List</p>
            <Image
                width={100}
                src="https://res.cloudinary.com/dv4fxot90/image/upload/v1601216430/docs/Screenshot_2020-09-27_at_17.19.47_iql037.png"
            /><br/><br/>
            <Image
                width={100}
                src="https://res.cloudinary.com/dv4fxot90/image/upload/v1601216430/docs/Screenshot_2020-09-27_at_17.19.56_zpxqr5.png"
            /><br/><br/>
            <p>По клику на кнопку more открывается выдвижная форма(Drawer). В режиме Admin в Drawere есть кнопка редактирования задачи</p>
            <Image
                width={400}
                src="https://res.cloudinary.com/dv4fxot90/image/upload/v1601216516/docs/Screenshot_2020-09-27_at_17.21.41_ghpenc.png"
            /><br/><br/>
            <p>В режиме Student в Drawere есть возможность оставить отзыв и оценку, если при создании или редактировании задачи Admin разрешил оставлять отзывы</p>
            <Image
                width={400}
                src="https://res.cloudinary.com/dv4fxot90/image/upload/v1601216627/docs/Screenshot_2020-09-27_at_17.22.59_xvozoq.png"
            /><br/><br/>
            <Image
                width={400}
                src="https://res.cloudinary.com/dv4fxot90/image/upload/v1601216627/docs/Screenshot_2020-09-27_at_17.23.12_rh3vfz.png"
            /><br/><br/>
        </>
    );
};

export default Taskpage;